import React from 'react'

import "./forecast.css"

export default function Forecast() {
  return (
    <div className='emas__home-forecast'>
        <h2 className='emas__home-forecast_top'>Describing current market dynamics</h2>
        <div className='emas__home-forecast_grid'>
            <div className='emas__home-forecast_grid-head'>
                <h2>Describing current market dynamics</h2>
            </div>
            <div className='emas__home-forecast_grid-renewable'>
                <h1>Expansion of rooftop solar</h1>
                <p>Rooftop solar is the main driver of the demand for electricity from the grid. We model rooftop solar output at the suburb level and account for trends in capacity and orientation when we develop our forecasts.</p>
            </div>
            <div className='emas__home-forecast_grid-coal'>
                <h1>Exit of coal power Generation</h1>
                <p>We track the application status of generation that will replace coal and model the most likely replacement technologies. </p>
            </div>
            <div className='emas__home-forecast_grid-other'>
                <h1>Windfarm output</h1>
                <p>Windfarm generation output depends on weather, location, capacity factors and the availability of transmission. We model wind from the bottom-up, using detailed simulations to develop our forecasts.</p>
            </div>
        </div>
    </div>
  )
}
